/// <reference path="../../svg.d.ts" />
import sellarLogo from "./assets/sellar-logo.svg?react";
import sellarLogoNew from "./assets/sellar-logo-new.svg?react";
import distributionTruck from "./assets/distribution-truck.svg?react";
import binoculars from "./assets/binoculars.svg?react";
import bottle from "./assets/bottle.svg?react";
import can from "./assets/can.svg?react";
import cask from "./assets/cask.svg?react";
import speedometer from "./assets/speedometer.svg?react";
import badge from "./assets/badge.svg?react";
import keg from "./assets/keg.svg?react";
import pageInfo from "./assets/page-info.svg?react";
import depositPayment from "./assets/deposit-payment.svg?react";
import pallet from "./assets/pallet.svg?react";
import hokodo from "./assets/hokodo.svg?react";
import two from "./assets/two.svg?react";

/**
 * Sellar-specific brand icons and unique shapes.
 * These are NOT deprecated.
 */
export const SellarIconsType = {
  BINOCULARS: binoculars,
  BOTTLE: bottle,
  CAN: can,
  CASK: cask,
  SPEEDOMETER: speedometer,
  BADGE: badge,
  KEG: keg,
  SELLAR: sellarLogo,
  SELLAR_NEW: sellarLogoNew,
  PAGE_INFO: pageInfo,
  DEPOSIT_PAYMENT: depositPayment,
  PALLET: pallet,
  HOKODO_ICON: hokodo,
  TWO_ICON: two,
  SELLAR_DISTRIBUTION_TRUCK: distributionTruck,
};
